import { render, staticRenderFns } from "./VRSpace.vue?vue&type=template&id=4e04b90a"
import script from "./VRSpace.vue?vue&type=script&lang=js"
export * from "./VRSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports